<template>
  <v-dialog max-width="500" v-model="localValue" @input="closeDialog">
    <v-card class="px-8 pt-4 pb-12">
      <v-btn icon @click="closeDialog" class="position-absolute modal-close">
        <v-icon clr="var(--v-gray2-base)">$modalClose</v-icon>
      </v-btn>
      <v-col class="text-center">
        <div class="font-Medium-16 gray1--text">
          {{ $t("accountPage.security.modals.numberChange.title") }}
        </div>
      </v-col>

      <v-row class="mt-2">
        <v-col class="py-0 pe-0" cols="2" md="1">
          <v-icon size="22" clr="var(--v-warning-base)">$warningWallet</v-icon>
        </v-col>
        <v-col class="py-0 ps-0">
          <span class="font-Regular-12 warning--text">
            {{ $t("accountPage.security.modals.numberChange.warning") }}
          </span>
        </v-col>
      </v-row>

      <div class="mt-5">
        <v-text-field
          :label="$t('accountPage.security.modals.numberChange.newNumber')"
          type="number"
          filled
          background-color="var(--v-field-base)"
          class="custom-form-control gray1--text login-form-control"
          v-model="newNumber"
          hide-details
        >
        </v-text-field>

        <v-text-field
          v-model="otpCode"
          :label="
            $t('accountPage.security.modals.numberChange.confirmationCode')
          "
          type="text"
          filled
          background-color="var(--v-field-base)"
          class="custom-form-control gray1--text login-form-control mt-5"
          hide-details
        >
          <template v-slot:append>
            <v-btn
              color="primary"
              outlined
              small
              class="py-4"
              style="margin-top: -7px"
              :disabled="!newNumber || showCounter"
              :loading="otpLoading"
              @click="getOtp()"
            >
              <CountdownTimer
                v-if="showCounter"
                @countdown-finished="counterFinished"
                :targetTime="expireTime"
              />
              <span v-else>{{
                $t("accountPage.security.modals.getCode")
              }}</span>
            </v-btn>
          </template>
        </v-text-field>

        <v-text-field
          v-model="password"
          :label="$t('accountPage.security.modals.password')"
          type="password"
          filled
          background-color="var(--v-field-base)"
          class="custom-form-control gray1--text login-form-control mt-5"
          hide-details
        >
        </v-text-field>

        <v-text-field
          v-model="google2fa"
          :label="$t('accountPage.security.modals.googleAuth')"
          type="text"
          filled
          background-color="var(--v-field-base)"
          class="custom-form-control gray1--text login-form-control mt-5"
          hide-details
        >
          <template v-if="!userVerifyInfo.is_google2fa_active" v-slot:append>
            <v-btn
              color="primary"
              outlined
              small
              class="py-4"
              style="margin-top: -7px"
              @click="redirectActive2Fa()"
            >
              {{ $t("accountPage.security.modals.activate") }}
            </v-btn>
          </template>
        </v-text-field>
      </div>

      <v-btn
        color="primary"
        block
        class="mt-8"
        x-large
        @click="confirm"
        :loading="confirmLoading"
      >
        {{ $t("accountPage.security.modals.confirm") }}
      </v-btn>
    </v-card>
  </v-dialog>
</template>

<script>
import * as types from "@/store/types";
import { mapGetters } from "vuex";
import { SecurityService } from "@/services";
import CountdownTimer from "@/components/Shared/CountdownTimer";
export default {
  props: ["value"],
  components: { CountdownTimer },
  data() {
    return {
      localValue: this.value,
      newNumber: null,
      otpCode: null,
      password: null,
      google2fa: null,
      otpLoading: false,
      confirmLoading: false,
      expireTime: null,
      showCounter: false
    };
  },
  computed: {
    ...mapGetters({
      userVerifyInfo: types.userVerifyInfo.getters.GET_USER_VERIFY_INFO
    })
  },
  watch: {
    value(newValue) {
      this.localValue = newValue;
    }
  },
  methods: {
    closeDialog() {
      this.localValue = false;
      this.$emit("input", false);
    },
    getOtp() {
      this.otpLoading = true;
      SecurityService.getMobileOtp({ mobile: this.newNumber })
        .then(response => {
          console.log(response.data);
          const endTime = response.data.data.expires_in;
          this.expireTime = parseFloat(endTime);
          localStorage.setItem("endTime", endTime);
          this.showCounter = true;
        })
        .finally(() => {
          this.otpLoading = false;
        });
    },
    confirm() {
      this.confirmLoading = true;
      SecurityService.changeMobile({
        mobile: this.newNumber,
        otp_code: this.otpCode,
        google2fa_code: this.google2fa,
        password: this.password
      })
        .then(response => {
          this.$toast.success(response.data.message);
          this.closeDialog();
          this.$router.go(0);
        })
        .finally(() => {
          this.confirmLoading = false;
        });
    },
    redirectActive2Fa() {
      this.closeDialog();
    },
    counterFinished() {
      this.showCounter = false;
      localStorage.removeItem("endTime");
    },
    init() {
      const endTime = localStorage.getItem("endTime");
      if (endTime) {
        this.expireTime = endTime;
        this.showCounter = true;
      }
    }
  }
};
</script>
